<!-- @format -->

<template>
  <div id="participantaddorupdate-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="createLoading == 'created'" key="create-loading" />
        <el-row v-else key="content">
          <el-col :span="24">
            <div class="custom-section-container pt-0">
              <div class="section-header" @click="settingsDock = !settingsDock">
                <div class="section-title">
                  <div class="section-head">
                    <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.registrationType") }}</label>
                    <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                  </div>
                  <span>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.registrationTypeMsg") }}</span>
                </div>
                <div class="section-accordion">
                  <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </div>
              </div>
              <transition name="el-zoom-in-top">
                <div class="section-wrapper" v-show="settingsDock">
                  <el-row :gutter="10">
                    <el-col :span="24">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.registrationForm") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.registrationFormMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select v-model="form.registrationFormId" :disabled="form.id != null" :class="$inputError('registrationFormId', validationErrors)">
                          <el-option v-for="formItem in formList" :key="formItem.id" :label="formItem.title" :value="formItem.id" :style="formItem.isActive == false ? 'background-color: #fff2f2;' : ''"></el-option>
                        </el-select>
                      </div>
                    </el-col>

                    <el-col :span="24" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.registrationPackage") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span v-html="$t('participantManagament.attendeeList.participant.addUpdateParticipant.registrationPackageMsg')"></span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select :disabled="form.registrationFormId == null" v-model="form.packetID" @change="packetChanged">
                          <el-option :value="'-1'" label="Manuel" :key="-1"></el-option>
                          <template v-if="formList.find(x => x.id == form.registrationFormId)">
                            <el-option v-for="packetItem in formList.find(x => x.id == form.registrationFormId).packets" :key="packetItem.packetId" :label="packetItem.title" :value="packetItem.packetId"></el-option>
                          </template>
                        </el-select>
                      </div>
                    </el-col>

                    <el-col :span="24" class="mt-3" v-if="registerForm != null && form.packetID != null && (form.packetID != '-1' && registerForm.packets.find(x => x.id == form.packetID) ? registerForm.packets.find(x => x.id == form.packetID).packetType == 1 : '')">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.participationDay") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span v-html="$t('participantManagament.attendeeList.participant.addUpdateParticipant.participationDayMsg')"></span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select v-model="form.dayRestrictions" multiple clearable>
                          <el-option v-for="(day, dayIndex) in getPacketsInfo().dayRestrictions" :key="dayIndex" :label="day.title" :value="new Date(new Date(new Date(day.date).getFullYear(), new Date(day.date).getMonth(), new Date(day.date).getDate()).setHours(3)).toISOString()"></el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :span="24" class="mt-3" v-if="registerForm != null && form.packetID == -1">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.participationDay") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span v-html="$t('participantManagament.attendeeList.participant.addUpdateParticipant.participationDayMsg')"></span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select v-model="form.dayRestrictions" multiple clearable>
                          <el-option v-for="(day, dayIndex) in eventDateList" :key="dayIndex" :label="$moment(new Date(day).toISOString()).format('DD MMMM YYYY, dddd')" :value="new Date(day).toISOString()"></el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <!-- 
                    <el-col :span="24" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.segmentation") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.segmentationMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select :disabled="form.packetID != '-1'" v-model="form.tagID" :class="$inputError('tagID', validationErrors)">
                          <el-option v-for="tagItem in tagList" :key="tagItem.id" :label="tagItem.title" :value="tagItem.id">
                            <template>
                              <i class="fas fa-circle mr-2" :style="'color:' + tagItem.color"></i>
                              <span>{{ tagItem.title }}</span>
                            </template>
                          </el-option>
                        </el-select>
                      </div>
                    </el-col> -->
                    <el-col :span="24" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.segmentation") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.segmentationMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select v-model="tagsList" multiple filterable clearable :key="packetChangeKey" @clear="tagsList = []" @remove-tag="clearTag($event)" :class="$inputError('tagID', validationErrors)">
                          <el-option v-for="tagItem in tagList" :key="tagItem.id" :label="tagItem.title" :disabled="tagItem.id == form.tagID && form.packetID != -1" :value="tagItem.id">
                            <template>
                              <i class="fas fa-circle mr-2" :style="'color:' + tagItem.color"></i>
                              <span>{{ tagItem.title }}</span>
                            </template>
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <!-- <el-col :span="24" class="mt-3">
                      <div class="registerform-input-container">
                        <div class="custom-label">
                          <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.subSegmentation") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.subSegmentationMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-select v-model="form.subTagIds" clearable @clear="form.subTagIds = []" multiple :class="$inputError('tagID', validationErrors)">
                          <el-option v-for="tagItem in tagList" :key="tagItem.id" :label="tagItem.title" :value="tagItem.id">
                            <template>
                              <i class="fas fa-circle mr-2" :style="'color:' + tagItem.color"></i>
                              <span>{{ tagItem.title }}</span>
                            </template>
                          </el-option>
                        </el-select>
                      </div>
                    </el-col> -->
                  </el-row>
                </div>
              </transition>
            </div>
          </el-col>

          <template v-if="form.packetID != null && form.registrationFormId != null">
            <el-col :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="registrationDock = !registrationDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.attendeeInformation") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                            <i class="el-icon-info"></i>
                          </el-tooltip> -->
                    </div>
                    <span :class="{ 'text-danger': validationErrors.some(x => x.key.includes('questions-')) }">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.attendeeInformationMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="registrationDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="registrationDock">
                    <el-row :gutter="10">
                      <el-col :span="14">
                        <RecursiveQuestionBuilder :form="form" :registrationForm="registerForm" v-for="(question, index) in availableQuestions.filter(x => x.parentQuestionId == null && x.parentAnswerId == null && x.type == 1000)" :key="question.id + index" :question="question" baseValidationKey="questions-" />
                        <RecursiveQuestionBuilder :form="form" :registrationForm="registerForm" v-for="(question, index) in availableQuestions.filter(x => x.parentQuestionId == null && x.parentAnswerId == null && x.type == 10001)" :key="question.id + index" :question="question" baseValidationKey="questions-" />
                        <RecursiveQuestionBuilder :form="form" :registrationForm="registerForm" v-for="(question, index) in availableQuestions.filter(x => x.parentQuestionId == null && x.parentAnswerId == null && x.type == 1)" :key="question.id + index" :question="question" baseValidationKey="questions-" />
                        <RecursiveQuestionBuilder :form="form" :registrationForm="registerForm" v-for="(question, index) in availableQuestions.filter(x => x.parentQuestionId == null && x.parentAnswerId == null && x.type == 2)" :key="question.id + index" :question="question" baseValidationKey="questions-" />
                      </el-col>
                      <el-col :span="10">
                        <div class="registration-question" style="display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center;">
                          <div class="sub-title">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.photo") }}</div>
                          <el-upload :on-progress="participantProgress" class="upload-registration profile-picture-upload" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=participantProfile&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="participantSuccess">
                            <div class="el-upload-dragger">
                              <img v-if="form.image" :src="form.image" class="avatar" />
                              <template v-else>
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text" v-html="$t('participantManagament.attendeeList.participant.addUpdateParticipant.photoDragMsg')"></div>
                              </template>
                            </div>
                          </el-upload>
                          <el-button type="primary" class="mb-2" size="mini" @click="takePictureModal = true" round>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.takePhoto") }}</el-button>

                          <span v-html="$t('participantManagament.attendeeList.participant.addUpdateParticipant.photoSizeMsg')"></span>
                        </div>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="24">
                        <RecursiveQuestionBuilder :form="form" :registrationForm="registerForm" v-for="(question, index) in availableQuestions.filter(x => x.parentQuestionId == null && x.parentAnswerId == null && x.type != 1000 && x.type != 10001 && x.type != 1 && x.type != 2)" :key="question.id + index" :question="question" :allQuestions="questionItems" :availableQuestions="availableQuestions" baseValidationKey="questions-" />
                      </el-col>
                    </el-row>
                  </div>
                </transition>
              </div>
            </el-col>

            <!-- <el-col :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="productDock = !productDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.additionalProduct") }}</label>
                   
                    </div>
                    <span :class="{ 'text-danger': validationErrors.some(x => x.key.includes('sub-events')) }">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.additionalProductMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="productDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="productDock">
                    <div class="d-flex flex-end justify-content-end mt-2 mb-2">
                      <el-button
                        type="primary"
                        size="mini"
                        icon="fas fa-plus"
                        @click="
                          updateProductForm = null;
                          updateProductFormIndex = null;
                          addProductDialog = true;
                        "
                        round
                        >{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addRegistration") }}</el-button
                      >
                    </div>

                    <template v-if="form.additionalProductRegistrations.length > 0">
                      <div class="custom-grid-table-header participant-addupdate-subevents-header">
                        <div></div>
                        <div>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.additionalProduct") }}</div>
                        <div></div>
                      </div>
                      <div class="participant-addupdate-subevents-container">
                        <div class="item-container" v-for="(item, index) in form.additionalProductRegistrations" :key="index + '-product-additional-index'" :class="{ 'error-border': validationErrors.some(x => x.key.includes('sub-events-' + index)) }">
                          <div class="item">
                            <div>
                              <span>#{{ index + 1 }}</span>
                            </div>
                            <div class="title">
                              <span>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.productName") }}</span>
                              <span>{{ getProduct(item.additionalProductId).title }}</span>
                            </div>
                            <div class="d-flex justify-content-end">
                              <el-button
                                size="mini"
                                circle
                                icon="fas fa-pen"
                                type="primary"
                                @click="
                                  updateProductForm = item;
                                  updateProductFormIndex = index;
                                  addProductDialog = true;
                                "
                              ></el-button>

                              <el-popconfirm class="ml-10" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.deleteSure')" @confirm="form.additionalProductRegistrations.splice(index, 1)" :cancel-button-text="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.cancel')" :confirm-button-text="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.deleteYes')" icon-color="red">
                                <el-button size="mini" circle icon="fas fa-trash" slot="reference" type="danger"></el-button>
                              </el-popconfirm>
                            </div>
                          </div>
                          <transition name="el-zoom-in-top">
                            <div class="details" v-if="activeSubItem == item.subEventID + 'active' + index ? true : false">
                              <HolaconLottie v-if="activeSubItemLoading == item.subEventID + 'created' + index" :key="'sub-event-item' + item.subEventID" />
                              <div class="question-list" v-else :key="'sub-event-content' + item.subEventID">
                                <div class="question-item" v-for="question in item.questions.filter(x => x.type != 500)" :key="question.id + 'subitemactive-question'">
                                  <div class="question-title">{{ getSubItemQuestion(question).title }}</div>
                                  <QuestionItem v-if="getSubItemQuestion(question) != null" :question="getSubItemQuestion(question)"></QuestionItem>
                                </div>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </div>
                    </template>
                    <el-alert v-else show-icon type="info" :title="$t('participantManagament.attendeeList.participant.addUpdateParticipant.titlesNoProductMsg')" :closable="false"></el-alert>
                  </div>
                </transition>
              </div>
            </el-col> -->
            <!-- <el-col :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="subeventDock = !subeventDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.subEvents") }}</label>
                    
                    </div>
                    <span :class="{ 'text-danger': validationErrors.some(x => x.key.includes('sub-events')) }">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.subEventsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="subeventDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="subeventDock">
                    <div class="d-flex flex-end justify-content-end mt-2 mb-2">
                      <el-button
                        type="primary"
                        size="mini"
                        icon="fas fa-plus"
                        @click="
                          updateSubEventForm = null;
                          updateSubEventFormIndex = null;
                          addSubEventDialog = true;
                        "
                        round
                        >{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addRegistration") }}</el-button
                      >
                    </div>

                    <template v-if="form.subEventRegistrations.length > 0">
                      <div class="custom-grid-table-header participant-addupdate-subevents-header">
                        <div></div>
                        <div>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.subEvent") }}</div>
                        <div></div>
                      </div>
                      <div class="participant-addupdate-subevents-container">
                        <div class="item-container" v-for="(item, index) in form.subEventRegistrations" :key="index" :class="{ 'error-border': validationErrors.some(x => x.key.includes('sub-events-' + index)) }">
                          <div class="item">
                            <div>
                              <span>#{{ index + 1 }}</span>
                            </div>
                            <div class="title">
                              <span>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.subEvent") }}</span>
                              <span>{{ getSubEvent(item.subEventID).title }}</span>
                            </div>
                            <div class="d-flex justify-content-end">
                              <el-button size="mini" circle icon="fas fa-search" @click="activetedSubItem(item, index)" type="default"></el-button>
                              <el-button
                                size="mini"
                                circle
                                icon="fas fa-pen"
                                type="primary"
                                @click="
                                  updateSubEventForm = item;
                                  updateSubEventFormIndex = index;
                                  addSubEventDialog = true;
                                "
                              ></el-button>

                              <el-popconfirm class="ml-10" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.deleteSure')" @confirm="form.subEventRegistrations.splice(index, 1)" :cancel-button-text="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.cancel')" :confirm-button-text="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.deleteYes')" icon-color="red">
                                <el-button size="mini" circle icon="fas fa-trash" slot="reference" type="danger"></el-button>
                              </el-popconfirm>
                            </div>
                          </div>
                          <transition name="el-zoom-in-top">
                            <div class="details" v-if="activeSubItem == item.subEventID + 'active' + index ? true : false">
                              <HolaconLottie v-if="activeSubItemLoading == item.subEventID + 'created' + index" :key="'sub-event-item' + item.subEventID" />
                              <div class="question-list" v-else :key="'sub-event-content' + item.subEventID">
                                <div class="question-item" v-for="question in item.questions.filter(x => x.type != 500)" :key="question.id + 'subitemactive-question'">
                                  <div class="question-title">{{ getSubItemQuestion(question).title }}</div>
                                  <QuestionItem v-if="getSubItemQuestion(question) != null" :question="getSubItemQuestion(question)"></QuestionItem>
                                </div>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </div>
                    </template>
                    <el-alert v-else show-icon type="info" :title="$t('participantManagament.attendeeList.participant.addUpdateParticipant.titlesNoSubEventMsg')" :closable="false"></el-alert>
                  </div>
                </transition>
              </div>
            </el-col> -->

            <!-- <el-col :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="summaryDock = !summaryDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.summary") }}</label>
                     
                    </div>
                    <span
                      :class="{
                        'text-danger': validationErrors.some(x => x.key.includes('accompaying-persons-')) || validationErrors.some(x => x.key.includes('additional-services-'))
                      }"
                      >{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.summaryMsg") }}</span
                    >
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="summaryDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="summaryDock">
                    <div class="d-flex flex-end justify-content-end mt-2 mb-2">
                      <el-button
                        type="primary"
                        size="mini"
                        icon="fas fa-plus"
                        @click="
                          updateAccompanyingForm = null;
                          updateAccompanyingIndex = null;
                          addAccompanyingDialog = true;
                        "
                        round
                        >{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addCompanion") }}</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        icon="fas fa-plus"
                        @click="
                          updateServiceForm = null;
                          updateServiceIndex = null;
                          addServiceDialog = true;
                        "
                        round
                        >{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addService") }}</el-button
                      >
                    </div>

                    <div class="custom-grid-table-header additional-services-header">
                      <div></div>
                      <div>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.serviceName") }}</div>
                      <div class="text-center">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.unitPrice") }}</div>
                      <div class="text-center">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.piece") }}</div>
                      <div class="text-center">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.amount") }}</div>
                      <div></div>
                    </div>
                    <div class="additional-services-container mb-1">
                      <div class="item-container" v-if="getPacketsInfo() != null">
                        <div class="item" v-if="registerForm && form.packetID && form.packetID != '-1'">
                          <div>#1</div>
                          <div class="services-title">
                            <div class="type">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.registration") }}</div>
                            <div class="title">{{ getPacketsInfo().title }}</div>
                          </div>
                          <div class="text-center">{{ getPacketsInfo().price }}</div>
                          <div class="text-center">{{ getPacketsInfo().packetType == 0 ? "1" : this.form.dayRestrictions.length }}</div>
                          <div class="text-center">
                            {{ getPacketsInfo().packetType == 0 ? getPacketsInfo().price : getPacketsInfo().price * this.form.dayRestrictions.length }}
                          </div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <div class="additional-services-container mb-1">
                      <div class="item-container" v-for="(person, personIndex) in form.accompayingPersons" :key="person.id + personIndex" :class="{ 'error-border': validationErrors.some(x => x.key.includes('accompaying-persons-' + personIndex + '-')) }">
                        <div class="item">
                          <div>#{{ personIndex + 1 }}</div>
                          <div class="services-title">
                            <div class="type">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.companion") }}</div>
                            <div class="title">{{ person.questions.find(x => x.type == 1000).answer + " " + person.questions.find(x => x.type == 10001).answer }}</div>
                          </div>
                          <div class="text-center">{{ person.price }} {{ getEnumsDisplay("Currency", person.currency) }}</div>
                          <div class="text-center">1</div>
                          <div class="text-center">{{ person.price }} {{ getEnumsDisplay("Currency", person.currency) }}</div>
                          <div>
                            <el-button size="mini" circle icon="fas fa-search" type="default" @click="activatedAccompanying(personIndex)"></el-button>
                            <el-button
                              size="mini"
                              circle
                              icon="fas fa-pen"
                              @click="
                                updateAccompanyingForm = person;
                                updateAccompanyingIndex = personIndex;
                                addAccompanyingDialog = true;
                              "
                              type="primary"
                            ></el-button>
                            <el-popconfirm class="ml-10" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.deleteSure')" @confirm="form.accompayingPersons.splice(personIndex, 1)" :cancel-button-text="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.cancel')" :confirm-button-text="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.deleteYes')" icon-color="red">
                              <el-button size="mini" circle icon="fas fa-trash" slot="reference" type="danger"></el-button>
                            </el-popconfirm>
                          </div>
                        </div>
                        <transition name="el-zoom-in-top" mode="out-in">
                          <div class="details" v-if="activeAccompanyingItem == personIndex + '-activeAccompanyingPerson' ? true : false">
                            <HolaconLottie v-if="activeAccompanyingItemLoading == personIndex + '-activeAccompanyingPerson'" :key="'accompanying-person-item' + personIndex" />
                            <div class="question-list" v-else :key="'accompanying-person-content' + personIndex">
                              <div class="question-item" v-for="question in person.questions" :key="question.id + 'subitemactive-question'">
                                <div class="question-title">{{ getAccompanyingItemQuestion(question).title }}</div>
                                <QuestionItem :question="getAccompanyingItemQuestion(question)" />
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>
                    </div>
                    <div class="additional-services-container mb-1">
                      <div class="item-container" v-for="(service, serviceIndex) in form.additionalServices" :key="service.id + serviceIndex" :class="{ 'error-border': validationErrors.some(x => x.key.includes('additional-services-' + serviceIndex + '-questions-')) }">
                        <div class="item">
                          <div>#{{ serviceIndex + 1 }}</div>
                          <div class="services-title">
                            <div class="type">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.additionalService") }}</div>
                            <div class="title">{{ getAdditionalService(service.additionalServiceId).title }}</div>
                          </div>
                          <div class="text-center">{{ service.price }} {{ getEnumsDisplay("Currency", service.currency) }}</div>
                          <div class="text-center">1</div>
                          <div class="text-center">{{ service.price }} {{ getEnumsDisplay("Currency", service.currency) }}</div>
                          <div>
                            <el-button size="mini" circle icon="fas fa-search" type="default" @click="activatedServiceItem(serviceIndex)"></el-button>
                            <el-button
                              size="mini"
                              circle
                              icon="fas fa-pen"
                              @click="
                                updateServiceForm = service;
                                updateServiceIndex = serviceIndex;
                                addServiceDialog = true;
                              "
                              type="primary"
                            ></el-button>
                            <el-popconfirm class="ml-10" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.deleteSure')" @confirm="form.additionalServices.splice(serviceIndex, 1)" :cancel-button-text="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.cancel')" :confirm-button-text="$t('participantManagament.registrationSearch.detailsParticipant.attendeeAccom.deleteYes')" icon-color="red">
                              <el-button size="mini" circle icon="fas fa-trash" slot="reference" type="danger"></el-button>
                            </el-popconfirm>
                          </div>
                        </div>
                        <transition name="el-zoom-in-top" mode="out-in">
                          <div class="details" v-if="activeServiceItem == serviceIndex + '-activeServiceItem' ? true : false">
                            <HolaconLottie v-if="activeServiceItemLoading == serviceIndex + '-activeServiceItem'" :key="'additional-service-item' + serviceIndex" />
                            <div class="question-list" v-else :key="'additional-service-content' + serviceIndex">
                              <div class="question-item" v-for="question in service.questions" :key="question.id + 'subitemactive-question'">
                                <div class="question-title">{{ getServiceItemQuestion(question).title }}</div>
                                <QuestionItem :question="getServiceItemQuestion(question)" />
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col> -->
          </template>
        </el-row>
      </transition>
    </div>

    <div class="modal-footer" slot="footer" v-if="form != null && createLoading != 'created'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.close") }}</el-button>
        <!-- <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash"> Sil</el-button>
        </el-popconfirm>
        </template> -->
      </div>
      <div class="right-buttons">
        <el-tooltip placement="top" :content="$t('participantManagament.attendeeList.participant.addUpdateParticipant.shoppingCardInfo')" v-if="registerForm != null && calculatePrice > 0">
          <div class="shopping-card">
            <i class="fas fa-shopping-basket"></i>
            <span>{{ $currency.format(calculatePrice, { code: $parseCurrency(registerForm.paymentInfo.currency) }) }}</span>
          </div>
        </el-tooltip>

        <el-button type="primary" :loading="loading == 'save'" :disabled="loading == 'save'" @click="save">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.save") }}</el-button>
      </div>
    </div>
    <el-dialog :title="$t('participantManagament.attendeeList.participant.addUpdateParticipant.titlesAddEditProduct')" :visible.sync="addProductDialog" :close-on-click-modal="false" class="medium" center append-to-body destroy-on-close>
      <AddProduct v-if="addProductDialog" :data="updateProductForm" :activeSubIndex="updateProductFormIndex" @addUpdate="addUpdateProduct" @deleteProduct="form.additionalProductRegistrations.splice(updateProductFormIndex, 1)" :selectedSubEvents="form.additionalProductRegistrations" @closeDialog="addProductDialog = false" />
    </el-dialog>
    <el-dialog :title="$t('participantManagament.attendeeList.participant.addUpdateParticipant.titlesAddEditSubEvent')" :visible.sync="addSubEventDialog" :close-on-click-modal="false" class="medium" center append-to-body destroy-on-close>
      <AddSubEvent v-if="addSubEventDialog" :data="updateSubEventForm" :activeSubIndex="updateSubEventFormIndex" @addUpdate="addUpdateSubEvent" :selectedSubEvents="form.subEventRegistrations" @closeDialog="addSubEventDialog = false" />
    </el-dialog>
    <el-dialog :title="$t('participantManagament.attendeeList.participant.addUpdateParticipant.titlesAddEditCompanion')" :visible.sync="addAccompanyingDialog" :close-on-click-modal="false" class="medium" center append-to-body destroy-on-close>
      <AddAccompanyingPerson v-if="addAccompanyingDialog" :registerForm="registerForm" @closeDialog="addAccompanyingDialog = false" :data="updateAccompanyingForm" @addUpdate="addUpdateAccompanying" :activeAccomPaying="updateAccompanyingIndex" />
    </el-dialog>
    <el-dialog :title="$t('participantManagament.attendeeList.participant.addUpdateParticipant.titlesAddEditServices')" :visible.sync="addServiceDialog" :close-on-click-modal="false" class="medium" center append-to-body destroy-on-close>
      <AddAdditionalService v-if="addServiceDialog" :registerForm="registerForm" @closeDialog="addServiceDialog = false" :data="updateServiceForm" @addUpdate="addUpdateService" :activeServiceIndex="updateServiceIndex" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="takePictureModal" :title="$t('participantManagament.registrationSearch.detailsParticipant.takePhoto')" class="medium" center append-to-body destroy-on-close>
      <AddPictureCamera v-if="takePictureModal" @closeDialog="takePictureModal = false" @setImage="setParticipantImage" />
    </el-dialog>
  </div>
</template>

<script>
import QuestionItem from "../register-form/Inputs/QuestionItem.vue";
import AddSubEvent from "./dialog/AddSubEvent.vue";
import AddProduct from "./dialog/AddAdditionalProduct.vue";
import AddAccompanyingPerson from "./dialog/AddAccompanyingPerson.vue";
import AddAdditionalService from "./dialog/AddAdditionalService.vue";
import AddPictureCamera from "./dialog/AddPictureCamera.vue";
import axios from "axios";
import RecursiveQuestionBuilder from "../participants/Questions.vue";
export default {
  props: ["id"],
  components: {
    AddAdditionalService,
    AddAccompanyingPerson,
    AddPictureCamera,
    RecursiveQuestionBuilder,
    AddSubEvent,
    QuestionItem,
    AddProduct
  },
  data() {
    return {
      packetChangeKey: +new Date(),
      takePictureModal: false,
      eventDateList: [],
      tagsList: [],
      summaryDock: false,
      subeventDock: false,
      productDock: false,
      registrationDock: true,
      updateProductForm: null,
      updateProductIndex: null,
      updateServiceForm: null,
      updateServiceIndex: null,
      updateSubEventFormIndex: null,
      updateSubEventForm: null,
      updateAccompanyingForm: null,
      updateAccompanyingIndex: null,
      addAccompanyingDialog: false,
      addProductDialog: false,
      addSubEventDialog: false,
      addServiceDialog: false,
      axios,
      registerForm: null,
      additionalDock: false,
      settingsDock: true,
      participantDock: false,
      createLoading: false,
      timeout: null,
      participantPercent: 0,
      loading: false,
      form: {
        registrationFormId: null,
        registrationInputs: [],
        packetID: null,
        dayRestrictions: [],
        tagID: null,
        image: "https://holacon.s3.eu-central-1.amazonaws.com/public/default/default-user.png",
        imagePublic: "https://holacon.s3.eu-central-1.amazonaws.com/public/default/default-user.png",
        id: null,
        subTagIds: [],
        additionalServices: [],
        accompayingPersons: [],
        subEventRegistrations: [],
        additionalProductRegistrations: []
      },
      currenyCode: null,
      questionItems: [],
      availableQuestions: [],
      activeSubItem: null,
      activeQuestions: [],
      activeSubItemLoading: false,
      accompayingQuestions: [],
      activeAccompanyingItem: null,
      activeAccompanyingItemLoading: false,
      activeServiceItem: null,
      activeServiceItemLoading: false,
      serviceQuestions: [],
      price: 0
    };
  },
  methods: {
    packetChanged() {
      this.form.dayRestrictions = [];
    },
    clearTag(event) {
      if (event == this.form.tagID && this.form.packetID != -1) {
        this.tagsList.unshift(event);
      }
    },
    setParticipantImage(image) {
      this.form.image = JSON.parse(JSON.stringify(image));
      this.form.imagePublic = JSON.parse(JSON.stringify(image));
    },
    getAdditionalService(id) {
      return this.registerForm.additionalServices.find(x => x.id == id);
    },
    getServiceItemQuestion(question) {
      var dammyQuestion = this.serviceQuestions.find(x => x.id == question.id);
      dammyQuestion.answer = question.answer;
      dammyQuestion.answers = question.answers;
      return dammyQuestion;
    },
    getAccompanyingItemQuestion(question) {
      var dammyQuestion = this.accompayingQuestions.find(x => x.id == question.id);
      dammyQuestion.answer = question.answer;
      dammyQuestion.answers = question.answers;
      return dammyQuestion;
    },
    getSubItemQuestion(question) {
      var dammyQuestion = this.activeQuestions.find(x => x.id == question.id);
      dammyQuestion.answer = question.answer;
      dammyQuestion.answers = question.answers;
      return dammyQuestion;
    },
    async activetedSubItem(item, index) {
      if (this.activeSubItem != item.subEventID + "active" + index) {
        this.activeSubItem = item.subEventID + "active" + index;
        if (this.timeout != null) clearTimeout(this.timeout);
        this.activeSubItemLoading = item.subEventID + "created" + index;
        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch("getQuestionsObject", { id: item.subEventID, type: 5 });
          this.activeQuestions = res.data.data.items;
          this.activeSubItemLoading = false;
        }, 500);
      } else {
        this.activeSubItem = null;
      }
    },
    async activatedAccompanying(personIndex) {
      if (this.activeAccompanyingItem != personIndex + "-activeAccompanyingPerson") {
        this.activeAccompanyingItem = personIndex + "-activeAccompanyingPerson";
        if (this.timeout != null) clearTimeout(this.timeout);
        this.activeAccompanyingItemLoading = personIndex + "-activeAccompanyingPerson";
        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch("getQuestionsObject", { id: this.form.registrationFormId, type: 6 });
          this.accompayingQuestions = res.data.data.items;
          this.activeAccompanyingItemLoading = false;
        }, 500);
      } else {
        this.activeAccompanyingItem = null;
      }
    },
    async activatedServiceItem(serviceIndex) {
      if (this.activeServiceItem != serviceIndex + "-activeServiceItem") {
        this.activeServiceItem = serviceIndex + "-activeServiceItem";
        if (this.timeout != null) clearTimeout(this.timeout);
        this.activeServiceItemLoading = serviceIndex + "-activeServiceItem";
        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch("getQuestionsObject", { id: this.form.registrationFormId, type: 1 });
          this.serviceQuestions = res.data.data.items;
          this.activeServiceItemLoading = false;
        }, 500);
      } else {
        this.activeServiceItem = null;
      }
    },
    getSubEvent(id) {
      return this.$store.state.subevents.items.find(x => x.id == id);
    },
    getProduct(id) {
      return this.$store.state.additionalProducts.items.find(x => x.id == id);
    },
    addUpdateService(service) {
      var cloneObject = JSON.parse(JSON.stringify(service));
      if (this.updateServiceIndex != null) {
        this.form.additionalServices.splice(this.updateServiceIndex, 1, cloneObject);
      } else {
        this.form.additionalServices.push(cloneObject);
      }
      this.addServiceDialog = false;
    },
    addUpdateAccompanying(person) {
      var cloneObject = JSON.parse(JSON.stringify(person));
      if (this.updateAccompanyingIndex != null) {
        this.form.accompayingPersons.splice(this.updateAccompanyingIndex, 1, cloneObject);
      } else {
        this.form.accompayingPersons.push(cloneObject);
      }
      this.addAccompanyingDialog = false;
    },
    addUpdateSubEvent(subEvent) {
      var cloneObject = JSON.parse(JSON.stringify(subEvent));
      if (this.updateSubEventFormIndex != null) {
        this.form.subEventRegistrations.splice(this.updateSubEventFormIndex, 1, cloneObject);
      } else {
        this.form.subEventRegistrations.push(cloneObject);
      }
      this.addSubEventDialog = false;
    },
    addUpdateProduct(product) {
      var cloneObject = JSON.parse(JSON.stringify(product));
      if (this.updateSubEventFormIndex != null) {
        this.form.additionalProductRegistrations.splice(this.updateSubEventFormIndex, 1, cloneObject);
      } else {
        this.form.additionalProductRegistrations.push(cloneObject);
      }
      this.addProductDialog = false;
    },
    async save() {
      if (this.tagsList.length > 0) {
        this.form.tagID = this.tagsList[0];
        this.form.subTagIds2 = this.tagsList.slice(1);
      }
      this.form.registrationInputs = JSON.parse(JSON.stringify(this.availableQuestions));
      this.form.registrationInputs.forEach(p => {
        if (p.answer != null) {
          p.answer = p.answer.toString();
        }
      });
      this.form.additionalServices.forEach(z => {
        z.questions.forEach(t => {
          if (t.answer != null) {
            t.answer = t.answer.toString();
          }
        });
      });
      this.form.subEventRegistrations.forEach(z => {
        z.questions.forEach(t => {
          if (t.answer != null) {
            t.answer = t.answer.toString();
          }
        });
      });
      this.form.accompayingPersons.forEach(z => {
        z.questions.forEach(t => {
          if (t.answer != null) {
            t.answer = t.answer.toString();
          }
        });
        // this.form.abstracts.forEach((z) => {
        //   z.questions.forEach((t) => {
        //     if (t.answer != null) {
        //       t.answer = t.answer.toString();
        //     }
        //   });
        // });
      });
      var payload = { ...this.form };
      if (payload.packetID == "-1") {
        payload.packetID = null;
      }
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "save";
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addOrUpdateParitipant", payload);
        if (!res.data.alert.hasError) {
          if (res.data.data.isCreated) {
            this.$emit("itemCreated", { id: res.data.data.item.id, participantNO: res.data.data.item.participantNO });
          }

          this.form = res.data.data.item;
          this.$store.state.participants.lastSelectecFormId = this.form.registrationFormId;
          this.$emit("closeDialog");
          this.$emit("refresh");
        }
        this.loading = false;
      }, 500);
    },
    participantProgress(event) {
      this.participantPercent = event.percent;
    },
    participantSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
        this.form.imagePublic = response.data.item.url;
      }
    },
    getPacketsInfo() {
      if (this.form.packetID != null) {
        var packet = this.registerForm.packets.find(x => x.id == this.form.packetID);
        // if(packet.dayRestrictions.length > 0) {

        // 	packet.dayRestrictions = packet.dayRestrictions.map(x => {
        // 		x = {
        // 			...x,
        // 			date: new Date(x.date).toISOString()
        // 		}
        // 		return x;
        // 	})
        // }
        return packet;
      }
      return null;
    },
    async loadRegisterFormAndQuestion() {
      if (this.form.registrationFormId != null) {
        var res2 = await this.$store.dispatch("getRegisterFormOne", this.form.registrationFormId);
        this.registerForm = res2.data.data.item;
        var res = await this.$store.dispatch("getQuestionsObject", { id: this.form.registrationFormId, type: 0 });
        this.questionItems = res.data.data.items;
        this.$nextTick(() => {
          if (this.form.registrationInputs.length > 0) {
            this.form.registrationInputs.map(x => {
              if (this.questionItems.find(y => y.id == x.registrationInputID) != null) {
                this.questionItems.find(y => y.id == x.registrationInputID).answer = x.answer;
                this.questionItems.find(y => y.id == x.registrationInputID).answers = x.answers;
              }
            });
          }
        });
        this.$nextTick(() => {
          this.availableQuestions = this.questionItems.filter(x => x.parentQuestionId == null && x.parentAnswerId == null && x.isActive == true);
        });
      }
    }
  },
  computed: {
    calculatePrice() {
      var price = this.price;
      if (this.form.packetID != null && this.form.packetID != -1) {
        var packet = this.getPacketsInfo();
        if (packet != null) {
          price = packet.price;
        }
      }
      this.availableQuestions.forEach(x => {
        if (x.answer != null && (x.type == 15 || x.type == 16) && !x.allowMultipleSelections) {
          var selectedOption = null;
          if (x.options.some(y => y.id == x.answer)) {
            var selectedOption = x.options.find(y => y.id == x.answer);
            if (selectedOption != null) {
              price += selectedOption.price;
            }
          }
        }
        if (x.answers != null && x.answers.length > 0 && ((x.type == 16 && x.allowMultipleSelections) || x.type == 100)) {
          var selectedOptions = x.options.filter(g => x.answers.some(c => c == g.id));
          var totalPrice = 0;
          selectedOptions.forEach(y => {
            totalPrice += y.price;
          });
          price += totalPrice;
        }
      });
      return price;
    },
    validationErrors() {
      return this.$store.getters.getParticipantValidation;
    },

    formList() {
      return this.$store.getters.getRegisterFormList;
    },
    tagList() {
      return this.$store.getters.getTagsList;
    }
  },
  async created() {
    this.tagsList = [];
    var dateArray = new Array();

    var a = new Date(this.$store.state.event.event.startDate);
    var b = new Date(this.$store.state.event.event.endDate);

    var currentDate = new Date(a.getFullYear(), a.getMonth(), a.getDate());
    while (currentDate <= b) {
      dateArray.push(new Date(currentDate));
      currentDate = currentDate.addDays(1);
    }

    dateArray.push(new Date(currentDate));
    currentDate = currentDate.addDays(1);

    dateArray.map(x => x.setHours(3));
    
    this.eventDateList = dateArray;
    if (this.timeout != null) clearTimeout(this.timeout);
    this.createLoading = "created";
    this.timeout = setTimeout(async () => {
      this.$store.commit("setParticipantValidationErrors", []);
      await Promise.all([this.$store.dispatch("getRegisterForm"), this.$store.dispatch("getTags"), this.$store.dispatch("getSubEvents")]);
      this.createLoading = false;
    }, 500);

    if (this.id != null && this.id != null) {
      var res = await this.$store.dispatch("getParticipantOne", this.id);
      var dammyForm = res.data.data.item;
      if (dammyForm.packetID == null) {
        dammyForm.packetID = "-1";
      }

      if (dammyForm.dayRestrictions != null) {
        dammyForm.dayRestrictions = dammyForm.dayRestrictions.map(x => new Date(new Date(x).setHours(3)).toISOString());
      }

      this.form = dammyForm;
      this.tagsList.push(this.form.tagID);
      this.tagsList.push(...this.form.subTagIds2);
      var res2 = await this.$store.dispatch("getRegisterFormOne", this.form.registrationFormId);
      this.registerForm = res2.data.data.item;
    } else if (this.$store.state.participants.lastSelectecFormId != null) {
      var fIndex = this.formList.findIndex(x => x.id == this.$store.state.participants.lastSelectecFormId);
      if (fIndex != -1) {
        this.form.registrationFormId = this.$store.state.participants.lastSelectecFormId;
      } else {
        this.$store.state.participants.lastSelectecFormId = null;
      }
    } else if (this.formList.length == 1) {
      this.form.registrationFormId = this.formList[0].id;
    }

    await this.loadRegisterFormAndQuestion();

    this.$watch("form.registrationFormId", async function() {
      await this.loadRegisterFormAndQuestion();
      this.form.packetID = null;
      this.form.tagID = null;
      this.form.dayRestrictions = [];
    });

    this.$watch("form.packetID", newVal => {
      if (newVal != "-1" && newVal != null) {
        if (!this.tagsList.some(x => x == this.registerForm.packets.find(y => y.id == this.form.packetID).tagID)) {
          this.tagsList.unshift(this.registerForm.packets.find(c => c.id == this.form.packetID).tagID);
        }
        this.form.tagID = this.registerForm.packets.find(x => x.id == this.form.packetID).tagID;
      } else {
        this.form.tagID = null;
      }
      this.packetChangeKey++;
    });
  }
};
</script>

<style lang="less" scoped>
#participantaddorupdate-dialog {
  @danger-color: #ff6565;
  .registration-question {
    width: 100%;
    transition: 1s;
    margin-top: 18px;
    text-align: left;

    .el-upload-dragger {
      width: 100% !important;
      border-radius: 8px;
      .avatar {
        object-fit: cover;
        aspect-ratio: 1;
        height: auto !important;
        width: 100%;
      }
    }

    .upload-registration {
      .el-upload {
        width: 100%;
      }
    }

    .profile-picture-upload {
      .el-upload {
        display: flex;
        flex-direction: column;
        align-items: center;
        .el-upload-dragger {
          aspect-ratio: 1 / 1;
          height: auto !important;
          border-radius: 50%;
          max-width: 150px;
          width: 150px !important;

          .el-icon-upload {
            font-size: 50px;
            margin: 12px 0 12px;
          }

          .el-upload__text {
            font-size: 13px;
          }
        }
      }
      .el-upload__tip {
        text-align: center;
      }
    }

    .el-select {
      width: 100%;
    }

    .sub-title {
      color: #292f3b;
      font-weight: 500;
      margin-bottom: 8px;
      font-size: 14px;

      span {
        color: @danger-color;
      }
    }

    .hint-text {
      color: #505763;
      font-size: 13px;
      font-weight: 400;
      margin-top: 3px;
      display: block;
    }
  }
}
.participant-addupdate-subevents-header {
  grid-template-columns: 36px 1fr 90px;
}
.participant-addupdate-subevents-container {
  & > .item-container {
    gap: 0.5rem;
    transition: all 0.5s;
    border-radius: 8px;
    padding: 10px;
    background-color: #f1f1f1;
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    & > .item {
      display: grid;
      gap: 0.5rem;
      grid-template-columns: 36px 1fr 90px;
      align-items: center;
      & > .title {
        display: flex;
        flex-direction: column;
        gap: 0.1rem;
        & > span:first-child {
          color: #666;
          font-weight: 500;
        }
        & > span:last-child {
          text-decoration: underline;
          color: #03658c;
          font-weight: bold;
        }
      }
      &:last-child {
        margin-bottom: unset;
      }
      &.passive {
        background-color: #fff2f2 !important;
      }
    }
  }
}
.additional-services-header {
  grid-template-columns: 36px 1fr 120px 80px 90px 120px;
}
.additional-services-container {
  & > .item-container {
    gap: 0.5rem;
    transition: all 0.5s;
    border-radius: 8px;
    padding: 10px;
    background-color: #f1f1f1;
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    & > .item {
      display: grid;
      gap: 0.5rem;
      grid-template-columns: 36px 1fr 120px 80px 90px 120px;
      align-items: center;
      & > .services-title {
        display: flex;
        flex-direction: column;
        gap: 0.3rem;
        .type {
          color: #666;
          font-weight: 500;
        }
        & > .title {
          text-decoration: underline;
          color: #03658c;
          font-weight: bold;
        }
      }
      &:last-child {
        margin-bottom: unset;
      }
    }
  }
}

#add-update-participants {
  padding: 1rem;
  padding-top: 0px;

  .register-type {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    color: black;
    .register-type-title {
      font-weight: bold;
    }
  }
}
</style>
<style lang="less">
.modal-base-small {
  min-width: 720px !important;
  max-width: 720px !important;
}
.ml-10 {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/participants/AddUpdateParticipant.vue